import { ruleDefinitionDefaults, defaultValidationTagRule, createValidator } from './TagRulesCommon'


const ruleDefinition =
{
    ...ruleDefinitionDefaults,
    ruleType: "TagProductsByStatus",
    title: "Auto Tag Products By Status",
    description: "Automatically tag products by using their Status attribute (ACTIVE, DRAFT, ARCHIVED). Easily tag products when status changes.",
    example: "Tag a product with tag \"state_active\" when its status changes to ACTIVE.",
    additional: [
        "You can specify a tag for just a single state, for multiple states, or for all states - DRAFT, ACTIVE, ARCHIVED",
        "Tags for previous states are cleared when product enters in new state",
    ],
    legacy: false,
    inProgress: false,
    previewType: "ProductTags",
    tags: ["Products", "Tags"],
    getDefaultRuleState: () => {
        return {
            name: null,
            trigger: "Automatic",
            settings: {
                ruleTypeId: "TagProductsByStatus",
                statusArchivedTag: null,
                statusActiveTag: null,
                statusDraftTag: null
            }
        }
    },
    createValidator: (onAsyncError) => {
        return createValidator(
            onAsyncError,
            [defaultValidationTagRule,
                (rule, errors) => { },
            ], null);
    }
};

export default ruleDefinition;